























































































































import Vue from "vue";
import * as types from "../../store/types";
import { rules, scrollToFirstInvalidElement } from "../../services/validation";
import { mapGetters, mapActions } from "vuex";

export default Vue.extend({
  name: "ApplicationStep6",

  props: {},

  data: () => {
    return {
      rules,
      formValue: {
        uploadEmployer: null,
        uploadSole: null,
        w9: null,
        uploadEmployerFile: null,
        uploadSoleFile: null,
        w9File: null,
        attachment1: null,
        attachment1File: null,
        attachment2: null,
        attachment2File: null,
        attachment3: null,
        attachment3File: null,
        eVerifyMou: null,
        eVerifyMouFile: null,
      } as Record<string, null | string | File>,
    };
  },

  methods: {
    ...mapActions({
      saveStep: types.SAVE_FORM_STEP,
    }),
    saveAndContinue() {
      this.saveStep({
        formFields: this.formValue,
      }).then(() => {
        // sometimes this if firing before the application-level validation, which reset the validation state, so we wait a little longer to be safe.
        setTimeout(() => {
          // @ts-ignore
          const isValid = this.$refs.form.validate();
          this.$emit("update-validity", 5, isValid);
          if (!isValid) {
            return scrollToFirstInvalidElement(this, this.$refs.form as Vue);
          }

          this.$emit("next-step");
        }, 500);
      });
    },
    save() {
      const sanitizedFormValues = {} as Record<string, null | File | string>;

      Object.keys(this.formValue).forEach((fieldName) => {
        const fileFieldNameProp =
          fieldName.indexOf("File") > -1
            ? fieldName.substr(0, fieldName.length - 4)
            : fieldName;

        const fileFieldProp =
          fieldName.indexOf("File") > -1 ? fieldName : fieldName + "File";

        // if we've processed this pair, continue
        if (fileFieldNameProp in sanitizedFormValues) return;

        const fileFieldName = this.formValue[fileFieldNameProp] as string;
        const fileField = this.formValue[fileFieldProp] as File | null;

        // only update what we're sending over it is set and valid
        if (fileField && fileField.size < 15728640) {
          sanitizedFormValues[fileFieldProp] = fileField;
          sanitizedFormValues[fileFieldNameProp] = fileFieldName;
        }
      });

      this.saveStep({
        formFields: sanitizedFormValues,
      });
    },
    updateValidity() {
      // @ts-ignore
      const formIsValid = this.$refs.form.validate();
      // @ts-ignore
      this.$refs.form.resetValidation();

      this.$emit("update-validity", 5, formIsValid);
    },
  },

  computed: {
    ...mapGetters({
      allFormValues: types.FORM_VALUES,
      saving: types.SAVING_FORM,
    }),
  },

  watch: {
    allFormValues: {
      immediate: true,
      handler() {
        // map this step's fields to Vuex's
        Object.keys(this.formValue).forEach(
          // @ts-ignore
          (key) => (this.formValue[key] = this.allFormValues[key])
        );

        setTimeout(() => this.updateValidity(), 50);
      },
    },
  },
});
